import { marketplace } from '@/axios'

export default {
  listDataTabl (url, filter) {
    return marketplace().get(url, {
      params: filter
    })
  },
  commonUploadFiles (payload, config) {
    return marketplace().post('media-files/upload', payload, config)
  },
  removeImage (id, type) {
    return marketplace().get(`remove-image/${id}/${type}`)
  },
  removeRow (url, rowId) {
    console.log(url, rowId)
    return marketplace().delete(`${url}/${rowId}`)
  },
  changeStatus (payload) {
    return marketplace().post('change-status', payload)
  }
}
